<template>
  <el-dialog title="修改密码" :visible.sync="dialogFormVisible" @open="handleDialogOpen" width="40%">
    <el-form :model="ruleForm" :rules="rules" ref="form" label-width="100px" status-icon>
      <el-form-item label="旧密码" prop="oldPwd">
        <el-input type="password" v-model="ruleForm.oldPwd" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd">
        <el-input type="password" v-model="ruleForm.newPwd" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="comfirmNewPwd">
        <el-input type="password" v-model="ruleForm.comfirmNewPwd" auto-complete="off"></el-input>
      </el-form-item>
      <div style="color:red;font-size:12px;margin-left:5px" >*密码长度采用8位以上，采用数字、大、小写字母、特殊符号任意三种字符组合方式*</div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="hideForm">取 消</el-button>
      <el-button size="mini" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import md5 from 'blueimp-md5'
  export default {
    data () {
      var validatePass = (rule, value, callback) => {
        if (!value) {
          callback()
        } else {
          let reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,}$/
          if (reg.test(value)) {
            callback()
          } else {
            return callback(new Error('密码格式错误，请重新输入！'))
          }
        }
      }
      // 验证密码是不是两次输入相同
      var validatePass2 = (rule, value, callback) => {
        if (value !== this.ruleForm.newPwd) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      }
      return {
        dialogFormVisible: false,
        ruleForm: {
          oldPwd: null,
          newPwd: null,
          comfirmNewPwd: null
        },
        rules: {
          oldPwd: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
          ],
          newPwd: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ],
          comfirmNewPwd: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      // 显示修改密码表单对话框
      showForm () {
        this.dialogFormVisible = true
        this.$nextTick(() => {
          if (this.$refs['form']) {
            // 清楚数据校验信息
            this.$refs['form'].clearValidate()
          }
        })
      },
      submitForm () {
        this.$refs['form'].validate((valid) => {
          if (!valid) {
            return
          }
          // TODO:向后端请求各种，上传表单
          this.$http.post(
            '/apps/admin/modifyPassword',
            {'password': md5(this.ruleForm.oldPwd), 'new_password': md5(this.ruleForm.newPwd)}
          ).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '密码修改成功'
              })
              // 关闭表单对话框
              this.dialogFormVisible = false
            } else {
              this.$message({
                message: response.data.msg,
                type: 'warning'
              })
            }
          })
        })
      },
      // 隐藏对话框
      hideForm () {
        this.dialogFormVisible = false
      },
      // 打开对话框的事件响应
      handleDialogOpen () {
        if (this.$refs['form']) {
          // 重置表单
          this.$refs['form'].resetFields()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/frame/PasswordForm.vue